/**
 * @license
 * Copyright© Celligence International, LLC - 2023
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 */
import React, { lazy, Suspense, useState, useEffect } from "react";
import "@fontsource/poppins";
import "../src/App.css";
import { CookieSetting } from "cookiesetting-component";
import Header from "./components/Header";
import Body from "./components/Body/Body";
import Contactus from "./components/ContactUs/Contactus";
import CacheBuster from "react-cache-buster";
import appversion from "../package.json";
import axios from "axios";
import jsonData from "./components/ai-branding.json"; // Import the JSON file

const Footer = lazy(() => import("./components/FooterNew/index.js"));
 
 
const WelcomeSection = lazy(() =>
  import("./components/WelcomeSection/WelcomeSection.js")
);

const MarkSection = lazy(() =>
  import("./components/MarkSection/MarkSection.js")
);

function App() {
  const isProduction = process.env.NODE_ENV === "production";
  const appVersion = appversion.version;
  const [links, setLinks] = useState(null); // Set initial state as null
  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const timestamp = Date.now(); // Generate a unique timestamp
        const url = `${process.env.REACT_APP_ANGELAI_JSON}?timestamp=${timestamp}`;
        const response = await axios.get(url);
        setLinks(response.data);
      } catch (error) {
        console.error("Error fetching links:", error);
        setLinks(jsonData); // Use local JSON data if fetching fails
      }
    };

    if (!links) {
      fetchLinks(); // Fetch JSON only if the links data is not available
    }
  }, [links]);

  useEffect(() => {
    if (!links) {
      setLinks(jsonData); // Set local JSON data as fallback initially
    }
  }, []);

  return (
    <CacheBuster
      currentVersion={appversion.version}
      isEnabled={isProduction} //If false, the library is disabled.
      isVerboseMode={false} //If true, the library writes verbose logs to console.
      // loadingComponent={<Loading />} //If not pass, nothing appears at the time of new version check.
      metaFileDirectory={"."} //If public assets are hosted somewhere other than root on your server.
    >
      <CookieSetting 
        privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK} 
        configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
        analytics={process.env.REACT_APP_ANALYTICS_PATH}
      />
      <div className="bodyContainer">
        {links ? (
          <>
            <Header fetchpriority="high" links={links.current} />
            <>
              <Body fetchpriority="high" links={links} />
              <Suspense fallback={<div />}>
                <WelcomeSection links={links.current} />
              </Suspense>
              <Suspense fallback={<div />}>
                <MarkSection links={links.current}/>
              </Suspense>
              <Contactus links={links.current} />
              <Suspense fallback={<div />}>
                <Footer links={links.current} />
              </Suspense>
            </>
          </>
        ) : (
          <div>Loading...</div>
        )}
      </div>
    </CacheBuster>
  );
}

export default App;
